// extracted by mini-css-extract-plugin
module.exports = {"custom":"_47fb6b55a8144957a4719707e86609e1-less","formItem":"_9053ee06160c2d189b6583dd76fa936d-less"};